import React from "react";
import Steeldivisionnone from "../components/Section/SteelDivisionone"
import SteelDivisiontwo from "../components/Section/SteelDivisiontwo";


function Automation() {
 

  return (
    <div className="bg-[#0C2341] mx-4 min-h-screen mt-2">
    
        <Steeldivisionnone />

        <SteelDivisiontwo />
    </div>
  );
}

export default Automation;
